import axios from 'axios';
import { toast } from 'react-toastify';

export async function loadCategoryOptions(categoryId) {
  const { data } = await axios.get(`/api/category/${categoryId}/options`);
  if (data.status === 'Ok') return data.options || [];
  throw new Error(data.message || 'Failed to load category options');
}

export async function createCategoryOption(categoryId, { Name, Cost }) {
  const { data } = await axios.post(`/api/category/${categoryId}/options`, { Name, Cost });
  if (data.status === 'Ok') return data.categoryOptionId;
  throw new Error(data.message || 'Failed to create category option');
}

export async function updateCategoryOption(categoryOptionId, { Name, Cost }) {
  const { data } = await axios.put(`/api/category/options/${categoryOptionId}`, { Name, Cost });
  if (data.status !== 'Ok') throw new Error(data.message || 'Failed to update category option');
}

export async function deleteCategoryOption(categoryOptionId) {
  const { data } = await axios.delete(`/api/category/options/${categoryOptionId}`);
  if (data.status !== 'Ok') throw new Error(data.message || 'Failed to delete category option');
}

export async function applyCategoryOptions(categoryId, { force = false } = {}) {
  const url = force
    ? `/api/category/${categoryId}/options/apply-force`
    : `/api/category/${categoryId}/options/apply`;
  const { data } = await axios.post(url);
  if (data.status === 'Ok') {
    const r = data.result || {};
    toast.success(
      force
        ? `Force applied: ${r.Created || 0} created`
        : `Applied: ${r.Created || 0} created, ${r.SkippedExcluded || 0} skipped (removed on product), ${r.SkippedExisting || 0} already present`
    );
    return data.result;
  }
  throw new Error(data.message || 'Failed to apply category options');
}

export async function syncCategoryOptions(categoryId) {
  const { data } = await axios.post(`/api/category/${categoryId}/options/sync`);
  if (data.status === 'Ok') {
    toast.success(`Synced name/cost to ${data.result?.Synced || 0} product options`);
    return data.result;
  }
  throw new Error(data.message || 'Failed to sync category options');
}
